<template>
  <main class="fixed_adjustment">
    <section>
      <div class="main_visual index_main_bg">
        <!-- <div class="main_pos">
          <p class="main_img">
            <img
              src="@/assets/img/index/index_main.png"
              alt="天下一品グッズ通販オリジナル商品"
              width="100%"
              height="auto"
            />
          </p>
        </div> -->
      </div>
    </section>
    <section v-if="newsList && newsList.result.length" class="inner01">
      <div class="news_container">
        <div class="inner">
          <h2 class="news_section_title">お知らせ</h2>
          <div class="news_card_grid">
            <div
              v-for="item in newsList.result"
              :key="item.id"
              class="news_card"
            >
              <div class="news_card_header" @click="toggleNews(item.id)">
                <div class="news_icon">
                  <i class="icon-announcement"></i>
                </div>
                <h3 class="news_card_title">{{ item.title }}</h3>
                <div
                  class="news_card_toggle"
                  :class="{ active: expandedNews[item.id] }"
                >
                  <i class="icon-chevron"></i>
                </div>
              </div>
              <div
                class="news_card_content"
                :class="{ active: expandedNews[item.id] }"
                v-html="item.detail"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="productDisplayList && productDisplayList.length">
      <div class="section_box">
        <div class="inner">
          <h2 class="tit_style02 mgb40">おすすめ商品</h2>
          <div class="index_sliderarea">
            <VueSlickCarousel
              class="index_slider"
              v-bind="settings"
              :key="productDisplayList.length"
            >
              <div
                v-for="product in productDisplayList"
                :key="product.id"
                class="index_slider_box"
              >
                <router-link :to="product.route" class="index_slider_box_card">
                  <div
                    class="three_column_img_area"
                    v-bind:style="{
                      background:
                        'transparent url(' +
                        product.main_image +
                        ') center / contain no-repeat',
                      'aspect-ratio': '4/3'
                    }"
                  ></div>
                  <div class="three_column_tit_area">
                    <h3 class="tit_style03">
                      <span class="sub_tit01">{{ product.name }}</span>
                    </h3>
                  </div>
                </router-link>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="section_box bg02">
        <div class="inner">
          <h2 class="tit_style02 mgb40">カテゴリから探す</h2>
          <ul class="three_column new_list">
            <li>
              <router-link
                :to="{
                  name: 'noodlesDetail',
                  params: { id: categoryThickId }
                }"
              >
                <div class="three_column_img_area01">
                  <img src="@/assets/img/index/top_img01.jpg" alt="こってり" />
                </div>
                <div class="three_column_tit_area01">
                  <h3 class="tit_style03">
                    <span class="sub_tit01">こってり</span>
                  </h3>
                </div>
              </router-link>
            </li>
            <!-- <li>
              <router-link :to="{ name: 'noodlesDetail', params: { id: 24 } }">
                <div class="three_column_img_area01">
                  <img src="@/assets/img/common/dammy06.jpg" alt="あっさり" />
                </div>
                <div class="three_column_tit_area01">
                  <h3 class="tit_style03">
                    <span class="sub_tit01">あっさり</span>
                  </h3>
                </div>
              </router-link>
            </li> -->
            <li>
              <router-link
                :to="{ name: 'noodlesDetail', params: { id: categoryMixId } }"
              >
                <div class="three_column_img_area01">
                  <img src="@/assets/img/index/top_img02.jpg" alt="ミックス" />
                </div>
                <div class="three_column_tit_area01">
                  <h3 class="tit_style03">
                    <span class="sub_tit01">ミックス</span>
                  </h3>
                </div>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  name: 'goodsList',
                  query: { categoryName: 'オリジナル商品' }
                }"
              >
                <div class="three_column_img_area01">
                  <img
                    src="@/assets/img/index/top_img10.png"
                    alt="オリジナル商品"
                  />
                </div>
                <div class="three_column_tit_area01">
                  <h3 class="tit_style03">
                    <span class="sub_tit01">オリジナル商品</span>
                  </h3>
                </div>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  name: 'goodsList',
                  query: { categoryName: '天下一品コラボ商品' }
                }"
              >
                <div class="three_column_img_area01">
                  <img
                    src="@/assets/img/index/top_img07.png"
                    alt="天下一品コラボ商品"
                  />
                </div>
                <div class="three_column_tit_area01">
                  <h3 class="tit_style03">
                    <span class="sub_tit01">天下一品コラボ商品</span>
                  </h3>
                </div>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  name: 'goodsList',
                  query: { categoryName: 'オリジナルどんぶり' }
                }"
              >
                <div class="three_column_img_area01">
                  <img
                    src="@/assets/img/index/top_img05.jpg"
                    alt="オリジナルどんぶり"
                  />
                </div>
                <div class="three_column_tit_area01">
                  <h3 class="tit_style03">
                    <span class="sub_tit01">オリジナルどんぶり</span>
                  </h3>
                </div>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  name: 'goodsList',
                  query: { categoryName: 'グッズ' }
                }"
              >
                <div class="three_column_img_area01">
                  <img src="@/assets/img/index/top_img09.jpg" alt="グッズ" />
                </div>
                <div class="three_column_tit_area01">
                  <h3 class="tit_style03">
                    <span class="sub_tit01">グッズ</span>
                  </h3>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="section_box">
      <h2 class="tit_style02 mgb40">はじめてご利用の方へ</h2>
      <div class="inner">
        <ul class="two_column mgb40">
          <li class="bg03">
            <router-link to="/guide" class="guide_box">
              <div class="guide_box_center">
                <h3 class="tit_style04">お買い物ガイド</h3>
              </div>
            </router-link>
          </li>
          <li class="bg04">
            <router-link to="/faq" class="guide_box">
              <div class="guide_box_center">
                <h3 class="tit_style04">よくあるご質問</h3>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
    <section class="section_box bg_gray">
      <div class="inner">
        <dl class="dl_list01">
          <dt><span class="icon06">送料について</span></dt>
          <dd>
            送料は地域や商品によって変動します。詳しくは
            <router-link
              class="under_line01"
              :to="{
                name: 'guide'
              }"
              >お買い物ガイド</router-link
            >
            をご確認ください。
          </dd>
        </dl>
      </div>
    </section>
  </main>
</template>

<script>
import $ from "jquery";
import { mapGetters } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import {
  // GET_LIST_GOODS,
  GET_PRODUCTS_BY_TAG_ID,
  GET_CART,
  GET_RECENT_NEWS_LIST
} from "@/store/actions.type";
export default {
  name: "HomePage",
  metaInfo: {
    title:
      "オンラインショップ｜天下一品 -鶏ガラベースのこってりラーメンが自慢!-",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "こってりスープが自慢の天下一品へいらっしゃい！こってりラーメンはネットでご注文頂けます。お店でもご自宅でも「天下一品自慢のこってり」をお楽しみください！"
      },
      {
        name: "Keywords",
        content:
          "ラーメン,こってり,あっさり,スープ,オンラインショップ,WEB屋台,採用,求人,アルバイト,中途採用,正社員,天一,天下一品"
      }
    ]
  },
  components: { VueSlickCarousel },
  created() {
    this.categoryThickId = process.env.VUE_APP_CATEGORY_THICK;
    this.categoryMixId = process.env.VUE_APP_CATEGORY_MIX;
    const RECOMMENDED_TAG_ID = process.env.VUE_APP_RECOMMEND_TAG;
    if (this.isAuthenticated) this.$store.dispatch(GET_CART);
    // this.getListNewGoods();
    this.$store.dispatch(GET_PRODUCTS_BY_TAG_ID, {
      id: RECOMMENDED_TAG_ID,
      sort: "default"
    });
    this.$store.dispatch(GET_RECENT_NEWS_LIST);
  },
  data() {
    return {
      categoryThickId: null,
      categoryMixId: null,
      expandedNews: {}, // 展開状態を管理
      settings: {
        // focusOnSelect: true,
        // infinite: true,
        // slidesToScroll: 1,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
        centerMode: false,
        arrows: false,
        centerPadding: "0",
        slidesToShow: 3,
        infinite: true,
        // adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["cart", "productList", "isAuthenticated", "newsList"]),
    productDisplayList() {
      let list = this.productList || [];
      return list.map(item => {
        let route = {};
        if (item.memo === "goods") {
          route = { name: "goods", params: { id: item.id } };
        } else {
          if (item.product_categories.length > 0) {
            route = {
              name: "noodlesDetail",
              params: { id: item.product_categories[0].category_id },
              query: { product_id: item.id }
            };
          }
        }
        return {
          ...item,
          route
        };
      });
    }
  },
  watch: {
    newsList(newVal) {
      if (newVal && newVal.result && newVal.result.length) {
        $(function() {
          $(".toggle_command").click(function() {
            $(this).toggleClass("selected");
            $(this)
              .next()
              .slideToggle();
          });
        });
      }
    }
  },
  methods: {
    toggleNews(newsId) {
      this.$set(this.expandedNews, newsId, !this.expandedNews[newsId]);
    }
    // getListNewGoods() {
    //   this.$store.dispatch(GET_LIST_GOODS, {
    //     offset: 0,
    //     itemsPerPage: 10,
    //     category_id: 26, //  32: "新商品"
    //     sort: "created_at.desc"
    //   });
    // }
  }
};
</script>

<style scoped lang="css">
.index_slider_box {
  max-width: 340px;
}

.index_slider_box_card {
  display: block;
  margin: 0 10px;
}

.index_slider_box_card > * {
  user-select: none;
  pointer-events: none;
}
</style>
